export default __webpack_public_path__ + "static/media/tvinsure-main-logo.07ef81c2.png";